import * as React from "react";
import { useHistory } from "react-router-dom";
const EditContextBase = React.createContext({
    message: "",
    // @ts-ignore
    dirty: React.createRef(),
});
export const EditContext = ({ message = "Änderungen wirklich verwerfen?", children, }) => {
    const dirty = React.useRef(false);
    return (React.createElement(EditContextBase.Provider, { value: { dirty, message } }, children));
};
export function useEditContextValidation() {
    const { dirty, message } = React.useContext(EditContextBase);
    const validate = () => {
        if (dirty.current) {
            if (!confirm(message)) {
                return false;
            }
            dirty.current = false;
        }
        return true;
    };
    return validate;
}
export function useEditContextBlock(changed) {
    const { dirty, message } = React.useContext(EditContextBase);
    const history = useHistory();
    const dispose = React.useRef(undefined);
    const reset = () => {
        var _a;
        dirty.current = false;
        (_a = dispose.current) === null || _a === void 0 ? void 0 : _a.call(dispose);
        dispose.current = undefined;
    };
    React.useEffect(() => {
        dirty.current = changed;
        if (changed) {
            // @ts-ignore
            dispose.current = history.block((proposedLocation) => {
                const currentLocation = history.location;
                if (currentLocation.pathname === proposedLocation.pathname) {
                    return null;
                }
                return message;
            });
            return () => {
                var _a;
                (_a = dispose.current) === null || _a === void 0 ? void 0 : _a.call(dispose);
                dispose.current = undefined;
            };
        }
    }, [changed]);
    React.useEffect(() => {
        // reset on unmount
        return reset;
    }, []);
    return reset;
}
//# sourceMappingURL=EditContext.js.map